import FormatUtils from "../../utils/FormatUtils";
import { IColInfo } from "./Interfaces";

export default class myExcelXML {
    _columnWidth: number = 80
    _link
    _colInfos: IColInfo[] = []
    _formatUtils: FormatUtils = new FormatUtils()

    downLoad(fileName: string, data: any[], colInfos: IColInfo[]) {
        if (colInfos)
            this._colInfos = colInfos

        if (data) {
            /*
            let finalDataArray: string[] = [];

            for (let i = 0; i < data.length; i++) {
                const flatenedData = this.flatten(data[i])
                finalDataArray.push(flatenedData);
            }

            const dataString = JSON.stringify(finalDataArray);
            const finalDataString = dataString.replace(/&/gi, '&amp;');
            */
            const worksheet = this.myXMLWorkSheet(fileName, data);
            var workbookStart: string = '<?xml version="1.0"?><?mso-application progid="Excel.Sheet"?><Workbook  xmlns="urn:schemas-microsoft-com:office:spreadsheet" xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" xmlns:html="http://www.w3.org/TR/REC-html40">';
            const workbookEnd: string = '</Workbook>';

            workbookStart += this.myXMLStyles();
            let workbook = workbookStart + worksheet + workbookEnd;

            const uri = 'data:text/xls;charset=utf-8,' + encodeURIComponent(workbook);
            this._link = document.createElement("a");
            this._link.href = uri;
            this._link.style = "visibility:hidden";
            this._link.download = fileName + ".xls";

            document.body.appendChild(this._link);
            this._link.click();
            document.body.removeChild(this._link);
        }
    }

    myXMLStyles() {
        let stylesStart = '<Styles>';
        const stylesEnd = '</Styles>'

        stylesStart += '<Style ss:ID="HeaderStyle"><Font ss:Bold="1"/></Style>'
        stylesStart += '<Style ss:ID="DateStyle"><NumberFormat ss:Format="Short Date"/></Style>'
        stylesStart += '<Style ss:ID="DateTimeStyle"><NumberFormat ss:Format="[$-409]d/m/yyyy\ HH:mm\ ;@"/></Style>'

        return stylesStart + stylesEnd;
    }

    myXMLWorkSheet(name, data) {
        const Table = this.myXMLTable(data);
        let WorksheetStart = '<Worksheet ss:Name="' + name + '">';
        const WorksheetEnd = '</Worksheet>';

        return WorksheetStart + Table + WorksheetEnd;
    }

    myXMLTable(data: any[]) {
        let TableStart = '<Table>';
        const TableEnd = '</Table>';

        //const tableData = JSON.parse(data);

        if (data.length > 0) {
            //const columnHeaders = Object.keys(data[0]);
            for (let i = 0; i < this._colInfos.length; i++) {
                TableStart += this.myXMLColumn(this._colInfos[i]);
            }

            let rowData = '';
            for (let j = 0; j < data.length; j++) {
                rowData += this.myXMLRow(data[j]);
            }

            TableStart += this.myXMLHead();
            TableStart += rowData;
        }

        return TableStart + TableEnd;
    }

    myXMLColumn(colInfo: IColInfo) {
        let width = this._columnWidth
        if (colInfo.ref.current) {
            let rect = colInfo.ref.current.getBoundingClientRect()
            width = rect.width / 1.5
        }

        return '<Column ss:AutoFitWidth="0" ss:Width="' + width + '"/>';
    }

    myXMLHead() {
        let HeadStart = '<Row ss:StyleID="HeaderStyle">';
        const HeadEnd = '</Row>';

        for (let i = 0; i < this._colInfos.length; i++) {
            const Cell = '<Cell><Data ss:Type="String">' + (this._colInfos[i].title ?? this._colInfos[i].dataProp ?? '') + '</Data></Cell>'
            HeadStart += Cell;
        }

        return HeadStart + HeadEnd;
    }

    myXMLRow(rowData) {
        let RowStart = '<Row>';
        const RowEnd = '</Row>';

        for (let i = 0; i < this._colInfos.length; i++) {
            const Cell = this.myXMLCell(rowData, this._colInfos[i]);
            RowStart += Cell;
        }

        return RowStart + RowEnd;
    }

    myXMLCell(rowData: any, colInfo: IColInfo) {
        let CellStart = '<Cell>';
        const CellEnd = '</Cell>';

        if (colInfo.dataType == 'date')
            CellStart = '<Cell ss:StyleID="DateStyle">'
        else if (colInfo.dataType == 'datetime')
            CellStart = '<Cell ss:StyleID="DateTimeStyle">'

        const Data = this.myXMLData(rowData, colInfo);
        CellStart += Data;

        return CellStart + CellEnd;
    }

    myXMLData(rowData: any, colInfo: IColInfo) {
        let type = 'String'
        switch (colInfo.dataType) {
            case 'money':
            case 'decimal':
            case 'percentage':
            case 'number':
                type = 'Number'
                break;
            case 'date':
            case 'datetime':
                type = 'DateTime'
                break;
            case 'bool':
                type = 'Boolean'
                break;
        }
        let DataStart = '<Data ss:Type="' + type + '">';
        const DataEnd = '</Data>';

        const cellContent = this.getValueOf(rowData, colInfo)

        return DataStart + cellContent + DataEnd;
    }

    flatten(obj): string {
        var obj1 = JSON.parse(JSON.stringify(obj));
        const obj2 = JSON.parse(JSON.stringify(obj));
        if (typeof obj === 'object') {
            for (var k1 in obj2) {
                if (obj2.hasOwnProperty(k1)) {
                    if (typeof obj2[k1] === 'object' && obj2[k1] !== null) {
                        delete obj1[k1]
                        for (var k2 in obj2[k1]) {
                            if (obj2[k1].hasOwnProperty(k2)) {
                                obj1[k1 + '-' + k2] = obj2[k1][k2];
                            }
                        }
                    }
                }
            }
            var hasObject = false;
            for (var key in obj1) {
                if (obj1.hasOwnProperty(key)) {
                    if (typeof obj1[key] === 'object' && obj1[key] !== null) {
                        hasObject = true;
                    }
                }
            }
            if (hasObject) {
                return this.flatten(obj1);
            } else {
                return obj1;
            }
        } else {
            return obj1;
        }
    }

    getValueOf(rowData: any, colInfo: IColInfo) {
        let value: any = null;
        if (colInfo.getCellData)
            value = colInfo.getCellData(rowData, colInfo);
        else if (colInfo.dataProp)
            value = colInfo.dataProp.split('.').reduce((o, i) => (o === null || o === undefined) ? null : o[i], rowData);

        if (value == null || value == undefined)
            value = '';
        else {
            switch (colInfo.dataType) {
                case 'decimal': return this._formatUtils.formatDecimal(value, colInfo.decimals ? colInfo.decimals : 2);
                case 'percentage': return this._formatUtils.formatPercentage(value);
                case 'money': return this._formatUtils.formatMoney(value, colInfo.decimals ? colInfo.decimals : 2);
                case 'bool': return this._formatUtils.formatBoolean(value, colInfo.trueValue ? colInfo.trueValue : 'Yes', colInfo.falseValue ? colInfo.falseValue : 'No');
                case 'user':
                case 'thumbnail': return value.name;
                case 'project': return value.id;
                case 'brand': return value.nameTree;
                case 'item': return value.itemNr;
                case 'itemrevision': return value.item.itemNr + ' - v' + value.revisionNumber;
            }
        }
        return value;
    }

}